import React from 'react'

const Youtubeembed = ({ videourl }) => {
    const vsrc = videourl;
    // console.log(vsrc)

    return (
        <div>
            <iframe
                src={vsrc}
                height="200px"
                width="100%"                // title="Career Choice Session with Dr. Arnab Basu, Co-founder &amp; CEO of Yancha"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
            ></iframe>
        </div>
    )
}

export default Youtubeembed